import {types} from '../../types';

const setGetInformationUsersAction = (payload) => {
    return {
        type: types.information.SET_USERS,
        payload,
      }
}

const setGetInformationSpinAction = (payload) => {
  return {
    type: types.information.SET_SPIN,
    payload
  }
}

const setGetDetalizationSpinAction = (payload) => {
  return {
    type: types.information.SET_DETALIZATION_SPIN,
    payload
  }
}

const setGetDetalizationAction = (payload) => {
  return {
    type: types.information.SET_DETALIZATION,
    payload
  }
}

const setGetNewUsersAction = (payload) => {
  return {
    type: types.information.SET_NEW_USERS,
    payload
  }
}

const setGetCountOnlineAction = (payload) => {
  return {
    type: types.information.SET_COUNT_ONLINE,
    payload
  }
}

export {
  setGetInformationUsersAction as SetGetInformationUsersAction,
  setGetInformationSpinAction as SetGetInformationSpinAction,
  setGetDetalizationSpinAction as SetGetDetalizationSpinAction,
  setGetDetalizationAction as SetGetDetalizationAction,
  setGetNewUsersAction as SetGetNewUsersAction,
  setGetCountOnlineAction as SetGetCountOnlineAction
}